import { css } from 'lit';

export const styles = css`
	:host {
		--_sds-details-text-color: var(--sds-details-text-color, var(--sds-color-text-default, var(--sds-color-main-text-default)));

		--_sds-details-summary-padding: var(--sds-details-summary-padding, var(--sds-spacing-xs));
		--_sds-details-summary-background-color: var(--sds-details-background-color, var(--sds-color-surface-default, var(--sds-color-main-surface-default)));
		--_sds-details-summary-gap: var(--sds-details-summary-gap, var(--sds-spacing-3xs));

		--_sds-details-content-padding-start: var(--sds-details-content-padding-start, calc(var(--_sds-details-summary-padding) + var(--_sds-details-summary-gap) + var(--sds-components-icon-md)));
		--_sds-details-content-padding: var(--sds-details-content-padding, var(--sds-spacing-xs));
		--_sds-details-content-background-color: var(--sds-details-background-color, var(--sds-color-surface-default, var(--sds-color-main-surface-default)));

		--_sds-details-focus-outline-width: var(--sds-details-focus-outline-width, var(--sds-border-md));
		--_sds-details-focus-outline-color: var(--sds-details-focus-outline-color, var(--sds-color-states-focus-outer));
		--_sds-details-focus-outline-offset: var(--sds-details-focus-outline-offset, var(--sds-color-states-focus-spacing));
		--_sds-details-focus-inner-color: var(--sds-details-focus-inner-color, var(--sds-color-states-focus-inner));

		--_sds-details-icon-transition: var(--sds-details-icon-transition, transform 0.2s ease);

		--_sds-details-border-color: var(--sds-details-border-color, var(--sds-color-border-subtle, var(--sds-color-main-border-subtle)));
		--_sds-details-border-bottom: var(--sds-details-border-bottom, solid 1px var(--_sds-details-border-color));
	}

	:host([data-palette]) {
		--_sds-details-text-color: var(--sds-details-text-color, var(--sds-color-text-default, var(--sds-color-main-text-default)));
		--_sds-details-summary-background-color: var(--sds-details-background-color, var(--sds-color-surface-default, var(--sds-color-main-surface-default)));
	}

	.sds-details {
		color: var(--_sds-details-text-color);

		&:is([open]) {
			--_sds-details-summary-background-color: var(----_sds-details-summary-background-color, var(--sds-color-surface-tinted, var(--sds-color-main-surface-tinted)));
		}

		&:not([data-standalone]) {
			border-top: solid 1px var(--_sds-details-border-color);
			border-bottom: var(--_sds-details-border-bottom);
		}

		/* Setting the border on the summary element preserves the border
		   when the element has focus
		*/
		&:is([data-standalone]) {
			summary {
				border-radius: var(--sds-radius-md);
				border: solid 1px var(--_sds-details-border-color);
			}

			&:is([open]) {
				& summary {
					border-bottom-left-radius: 0px;
					border-bottom-right-radius: 0px;
				}

				& .sds-details__content {
					border-left: solid 1px var(--_sds-details-border-color);
					border-right: solid 1px var(--_sds-details-border-color);
					border-bottom: solid 1px var(--_sds-details-border-color);
					border-bottom-left-radius: var(--sds-radius-md);
					border-bottom-right-radius: var(--sds-radius-md);
				}
			}
		}
	}

	.sds-details__summary {
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: var(--_sds-details-summary-padding);
		background-color: var(--_sds-details-summary-background-color);
		gap: var(--_sds-details-summary-gap);
		list-style: none;
		user-select: none;

		&:hover {
			--_sds-details-summary-background-color: var(--sds-details-summary-background-color, var(--sds-color-surface-hover, var(--sds-color-main-surface-hover)));
		}

		&:active {
			--_sds-details-summary-background-color: var(--sds-details-summary-background-color, var(--sds-color-surface-active, var(--sds-color-main-surface-active)));
		}

		&:focus-visible {
			box-shadow: 0 0 0 var(--sds-color-states-focus-spacing) var(--_sds-details-focus-inner-color);
			outline: var(--_sds-details-focus-outline-width) solid var(--_sds-details-focus-outline-color);
			outline-offset: var(--_sds-details-focus-outline-offset);
		}
	}

	.sds-details__summary-content {
		flex: 1;
		min-width: 0;
	}

	sds-icon {
		transition: var(--_sds-details-icon-transition);
	}

	.sds-details:not([open]) sds-icon {
		transform: rotate(180deg);
	}

	.sds-details__content {
		padding: var(--_sds-details-content-padding);
		padding-inline-start: var(--_sds-details-content-padding-start);
	}

	@media (prefers-reduced-motion: no-preference) {
		.sds-details__content {
			animation: show-content-keyframes 200ms ease-in-out;
		}
	}

	@keyframes show-content-keyframes {
		from {
			opacity: 0;
			transform: translateY(-0.5rem);
		}
		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	::slotted([slot='summary']) {
		display: inline;
		margin: 0;
	}
`;
